<div headerContent class="document-info flex items-center" [formGroup]="form">
    <app-content-field label="DISCREPANCY PROGRESS" [rowGap]="false">
        <span class="flex items-center gap-7 text-xxs">
            <app-progress-bar
                variant="secondary"
                mode="determinate"
                style="height: 12px; width: 100px"
                [progress]="progressValue" />
            @if (document) {
                <span
                    class="flex items-center whitespace-nowrap"
                    [class.color-yellow-green7]="allCompleted">
                    {{ document.progress.completed }}/{{
                        document.progress.total
                    }}
                    Completed
                    @if (allCompleted) {
                        <mat-icon svgIcon="check" style="height: 16px" />
                    }
                </span>
            }
        </span>
    </app-content-field>
    @if (document) {
        @if (mode === 'detail' && isAdmin) {
            <app-priority-select
                label="PRIORITY"
                variant="secondary"
                formControlName="priority"
                [value]="document.priority"
                [options]="prioOptions"
                style="width: 110px"
                selectStyle=" height: 22px" />
        } @else {
            <app-content-field label="PRIORITY" [rowGap]="false">
                <app-priority-field [priority]="document.priority" />
            </app-content-field>
        }
        <app-content-field label="LAST ACTIVITY" [rowGap]="false">
            <span class="flex items-center whitespace-nowrap">
                {{ getFormattedDate(document.latestActivity.createdAt) }}
                <app-tooltip>
                    <mat-icon trigger svgIcon="info" />
                    <div content>
                        {{ document.latestActivity.logMessage }}
                        <b>({{ document.latestActivity.user }})</b>
                    </div>
                </app-tooltip>
            </span>
        </app-content-field>
    }
    @if (document) {
        <div class="flex items-center gap-2 ml-auto">
            <app-collaborators-collapsible
                *wfeFeatureFlag="'CollaboratorsSectionEnabled'"
                [documentId]="document.id"
                [documentName]="document.name"
                [mode]="mode"
                [readOnly]="allAnalystsAreDocumentCollaborators" />

            @if (mode === 'summary') {
                <div
                    class="separator"
                    *wfeFeatureFlag="'CollaboratorsSectionEnabled'"></div>
            }

            @if (document.daysToPublish && mode === 'detail') {
                <div
                    class="separator"
                    style="margin: 0 15px 0 10px"
                    *wfeFeatureFlag="'CollaboratorsSectionEnabled'"></div>
                <span class="flex items-center text-xs">
                    {{ document.daysToPublish }} days to auto publish
                    <app-tooltip>
                        <mat-icon svgIcon="info" trigger />
                        <div content style="width: 400px">
                            After {{ document.daysToPublish }} days
                            {{ document.name }} will be published to RMS and be
                            removed from Workflow Inbox.
                        </div>
                    </app-tooltip>
                </span>
                <app-flat-button
                    variant="cta"
                    [dataQa]="dataQa.triggerPublishDocumentModalButton"
                    (clicked)="openPublishDocumentModal()">
                    Publish Document
                </app-flat-button>
            }
        </div>
    }
</div>
